var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightGrayArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.083 10C19.083 10.4142 18.7472 10.75 18.333 10.75L1.66634 10.75C1.25213 10.75 0.916342 10.4142 0.916342 10C0.916342 9.58578 1.25213 9.25 1.66634 9.25L18.333 9.25C18.7472 9.25 19.083 9.58579 19.083 10Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3027 18.0303C10.0098 17.7374 10.0098 17.2626 10.3027 16.9697L17.2723 10L10.3027 3.03033C10.0098 2.73744 10.0098 2.26256 10.3027 1.96967C10.5956 1.67678 11.0704 1.67678 11.3633 1.96967L18.8633 9.46967C19.1562 9.76256 19.1562 10.2374 18.8633 10.5303L11.3633 18.0303C11.0704 18.3232 10.5956 18.3232 10.3027 18.0303Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGrayArrow);
export default __webpack_public_path__ + "static/media/right-gray-arrow.d4d06bb686517e4c5562d30a1fe0d377.svg";
export { ForwardRef as ReactComponent };